import { PipeObject, Token } from '../types';
import { AddCssClassToBody } from '../../utils/add-css-class-body/add-css-class-body';

let classAdded = false;
export const List = () => {
  return ({ input, data, lex }: PipeObject) => {
    // loop through and get the start of a list
    // we need to keep track from start to end of list section
    // once we have that, that is one list that we can replace within a range (start-> end)
    let obj: Token;
    // keeps track of every list section (start of list to end of list)
    let listSections: Array<any> = [];
    let continuingList = 0;
    let listCounter = 0;
    while ((obj = lex.next())) {
      let listStart, listEnd;
      if (obj.token === 'list_ordered' || obj.token === 'list_unordered') {
        // the current line has a list. keep looping until we find the end
        listStart = obj;
        while ((obj = lex.next())) {
          if (obj.token === 'new_line' || obj.token === 'element_start') {
            // we found the end of the line, mark it
            listEnd = obj;
            break;
          }
        }
      }

      let listType;
      // if we have a dash, check if previous token is a new line. continue if it is
      // this is so we don't mark  "text - with dash" as a list
      const isPrevTokenNewLine =
        input.substring(listStart?.begin - 1, listStart?.begin) === '\n' ||
        listStart?.begin === 0;
      if (listStart && listEnd && isPrevTokenNewLine) {
        const searchValue = input.substring(listStart.begin, listEnd.begin);
        const value = input.substring(listStart.end, listEnd.begin).trim();
        const li = searchValue.trim().charAt(0).trim();
        listType = li === '-' ? 'ul' : 'ol';

        if (searchValue) {
          if (continuingList === 0) {
            // keep track of list section
            listSections[listCounter] = {
              start: listStart.begin,
              value:
                (listSections[listCounter]?.value || '') +
                `<${listType} class="cvna-parser-list">`,
            };
          }
          continuingList = 1;
          let howManySpaces = 0;
          // get start of `-`, and go backwards in the string
          // we're looking for the start of the line `\n`
          // and we count how many spaces between the `-` and the start of line `\n`
          // so we know how many indents we need to add to our list html
          for (
            let index = input.indexOf(li, listStart.begin);
            index > 0;
            index--
          ) {
            if (input.substring(index).charAt(0) === '\n' || index === 1) {
              break;
            } else if (input.substring(index).charAt(0) === ' ') {
              howManySpaces++;
            }
          }

          // if we have spaces, the list item needs to be indented (wrapped in ol/ul)
          if (howManySpaces > 2) {
            let startul = '';
            let endul = '';
            // check for max spaces of 12 and don't do math
            const minusMath = howManySpaces === 12 ? 0 : 1;
            for (let i = 0; i < howManySpaces / 3 - minusMath; i++) {
              startul = startul + `<${listType}>`;
              endul = endul + `</${listType}>`;
            }

            listSections[listCounter] = {
              ...listSections[listCounter],
              value:
                listSections[listCounter]?.value +
                `${startul}<li> ${value}</li>${endul}`,
            };
          } else {
            listSections[listCounter] = {
              ...listSections[listCounter],
              value: listSections[listCounter]?.value + `<li> ${value}</li>`,
            };
          }
        }
      } else {
        if (continuingList === 1) {
          // if list section was started, end it and add to list counter
          listSections[listCounter] = {
            ...listSections[listCounter],
            end: obj.begin,
            value:
              listSections[listCounter]?.value +
              `</${
                listType ||
                listSections[listCounter]?.value?.substring(1, 3) ||
                'ul'
              }>`,
          };
          listCounter++;
        }
        continuingList = 0;
      }
    }

    if (listSections.length > 0 && !classAdded) {
      // add special class to body so we can use css
      classAdded = AddCssClassToBody(
        `
      .cvna-parser-list {
        margin-left: 0px;
        margin-bottom: 0px;
      }

      .cvna-parser-list li::before {
        margin-left: -20px;
        margin-right: 10px;
      }
      `
      );
    }

    let newInput = input;
    for (let index = 0; index < listSections.length; index++) {
      const { start = 0, end = input.length, value } = listSections[index];
      newInput = newInput.replace(input.substring(start, end - 1), value);
    }

    return { input: newInput, data, lex };
  };
};
